import React, {useEffect, useState} from 'react';
import TableComponent from '../../../components/table';
import PaginationComponent from '../../../components/pagination';
import Api from "../../../services/api";
import {toast} from "react-toastify";
import LoadingComponent from "../../../components/loading";
import DateComponent from "../../../components/datepicker";
import moment from "moment";
import {useParams} from "react-router-dom";
import InputComponent from "../../../components/input";
import { END_DATE, START_DATE } from '../../../utility';

function RevenueIAA() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [startDate,setStartDate] = useState(moment().subtract(START_DATE, 'days'));
    const [endDate,setEndDate] = useState(moment().subtract(END_DATE, 'days'));
    const [AdSource,setAdSource] = useState('');
    const [SubAdSource,setSubAdSource] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(4);
    const [show, setShow] = useState(false);

    const { code, os } = useParams();

    const handleChangeDate = (event, picker) => {
        setStartDate(picker.startDate)
        setEndDate(picker.endDate)
    };

    const handleChangePage = (page) => {
        setCurrentPage(page);
    }

    const formatNumber = (num) => num.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

    const formatDateTime = (dateString) => {
        return moment(dateString).format('DD/MM/YYYY');
    };

    const onChangeSubAdSource = (e) => {
        setSubAdSource(e);
        setLoading(!loading);
    }

    const onChangeAdSource = (e) => {
        setAdSource(e);
        setLoading(!loading);
    }

    const fetchData = () => {
        setLoading(true);
        Api.get(`/api/monetization/revenue_iaa?os=${os}&code=${code}&ad_source=${AdSource}&sub_ad_source=${SubAdSource}&from=${startDate.format('YYYY-MM-DD')}&to=${ endDate.format('YYYY-MM-DD')}&page=${currentPage}`)
            .then(result => {
                if (result.data.code == 0) {
                    setData(result.data.data);
                    setCurrentPage(result.data.page)
                    setTotalPage(result.data.total_page)
                } else {
                    toast.error("Lỗi lấy dữ liệu !!");
                }
                setLoading(false)
            }).catch(() => {
                setLoading(false);
                toast.error("Đã có lỗi xảy ra khi gọi API!");
            });
    };

    useEffect(() => {
        fetchData();
    }, [startDate, endDate, currentPage, code,os, AdSource, SubAdSource]);

    return (
        <>
            <section className="main__filter">
                <div className="filter">
                    <div className="container-fluid">
                        <form action="" method="get" id="form">
                            <div className="row d-flex flex-row-reverse">
                                <div className="col-md-2">
                                    <div className="form-group" style={{marginBottom: "0"}}>
                                        <div className="filter-sticky">
                                            <div className="d-flex justify-content-end">
                                                <DateComponent startDate={startDate}
                                                               endDate={endDate}
                                                               handleChangeDate={handleChangeDate}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <InputComponent className="col-md-2"
                                                placeholder="Sub ad source"
                                                onChange={onChangeSubAdSource} />
                                <InputComponent className="col-md-2"
                                                placeholder="Ad source"
                                                onChange={onChangeAdSource} />
                            </div>
                        </form>
                    </div>
                </div>
            </section> 
            <section className="main__content">
                <div className="container-fluid">
                    <div className="detail-body">
                        <div className="overview_content pd-20">
                            <div className="mb-4">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="title-head-box">
                                            <p className="title-block">Revenue IAA</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mb-4">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="box box--chart mb-4">
                                            <div className="box__content custom-table">
                                                <LoadingComponent loading={loading} />
                                                <div className="table-responsive">
                                                    <div className="table-responsive">
                                                        <table className="table table-hover m-0 table--text-bold">
                                                            <thead>
                                                            <tr className="border-bt">
                                                                <th scope="col">Ad source</th>
                                                                <th scope="col">Sub ad source</th>
                                                                <th scope="col">Ad format</th>
                                                                <th scope="col" className="text-center">Ad request</th>
                                                                <th scope="col" className="text-center">Unit ID</th>
                                                                <th scope="col" className="text-center">Clicks</th>
                                                                <th scope="col" className="text-center">Earning</th>
                                                                <th scope="col" className="text-center">Ecpm</th>
                                                                <th scope="col" className="text-center">Impression</th>
                                                                <th scope="col" className="text-center">Impressions ctr</th>
                                                                <th scope="col" className="text-center">Match rate</th>
                                                                <th scope="col" className="text-center">Matched request</th>
                                                                <th scope="col" className="text-center">Responses</th>
                                                                <th scope="col" className="text-center">Date</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {data.length > 0 ? (
                                                                data.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{item.ad_source}</td>
                                                                        <td>{item.sub_ad_source}</td>
                                                                        <td>{item.ad_format}</td>
                                                                        <td className="text-center">{formatNumber(item.ad_request)}</td>
                                                                        <td className="text-center">{item.unit_id}</td>
                                                                        <td className="text-center">{formatNumber(item.clicks)}</td>
                                                                        <td className="text-center">{formatNumber(item.earning)}</td>
                                                                        <td className="text-center">{formatNumber(item.ecpm)}</td>
                                                                        <td className="text-center">{formatNumber(item.impression)}</td>
                                                                        <td className="text-center">{formatNumber(item.impressions_ctr)}</td>
                                                                        <td className="text-center">{formatNumber(item.match_rate)}</td>
                                                                        <td className="text-center">{formatNumber(item.matched_request)}</td>
                                                                        <td className="text-center">{formatNumber(item.responses)}</td>
                                                                        <td className="text-center">{formatDateTime(item.date)}</td>
                                                                    </tr>
                                                                ))) : (
                                                                <tr>
                                                                    <td colSpan="17" className="border border-gray-300 px-4 py-2 text-center">
                                                                        No data available
                                                                    </td>
                                                                </tr>
                                                            )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <PaginationComponent
                                            current={currentPage}
                                            total={totalPage}
                                            handleChangePage={handleChangePage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default RevenueIAA;
